import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { FolderFileDeletionFragment } from "src/core/gql/graphql";
import { useDeleteFolderEntity } from "src/core/hooks/folder/footer/useDeleteFolderEntity";
import { useRequiredTenantPaths } from "src/core/hooks/routing/useTenantPaths";
import { toast } from "src/core/hooks/use-toast";

export const useDeleteFolderController = (folderFile: FolderFileDeletionFragment) => {
  const { t } = useTranslation();

  const paths = useRequiredTenantPaths();
  const navigate = useNavigate();

  const { deleteFolderEntity, loading } = useDeleteFolderEntity();

  const confirm = async () => {
    if (!folderFile) return;

    try {
      await deleteFolderEntity(folderFile);
      toast({ description: t("folder.deleteFolder.success") });
      navigate(paths.home());
    } catch (error) {
      console.error("[DeleteFolderModal] delete error", error);
      toast({ description: t("folder.deleteFolder.error"), variant: "destructive" });
    }
  };

  return { loading, confirm };
};
